import { ReactElement, Ref, forwardRef, useState } from "react";
import { ClickableAreaPosition, ListItem } from "../../../ListItem";
import { FontIconName, IconButtonLike } from "client/Components";
import { generateTrackingId } from "client/Misc/utils";

const {
	ClickableArea
} = ListItem;

export type ActionButtonProps = {
	onClick(): void;
	position?: ClickableAreaPosition;
	icon: FontIconName;
	trackingId: string;
	isActive?: boolean;
	shouldOnlyBeVisibleOnHover?: boolean;
};

export const ActionButton = forwardRef(
	(props: ActionButtonProps, ref: Ref<HTMLElement>): ReactElement => {
		const {
			onClick,
			position,
			icon,
			isActive,
			shouldOnlyBeVisibleOnHover,
			trackingId
		} = props;

		const [isBeingHovered, setIsBeingHovered] = useState<boolean>(false);
		const isButtonActive: boolean = isActive === true || isBeingHovered;

		return (
			<ClickableArea
				onClick={onClick}
				shouldOnlyBeVisibleOnHover={shouldOnlyBeVisibleOnHover}
				position={position}
				trackingId={trackingId}
				onMouseEnter={() => setIsBeingHovered(true)}
				onMouseLeave={() => setIsBeingHovered(false)}
			>
				<IconButtonLike
					icon={icon}
					kind="transparent"
					shape="round"
					trackingId={generateTrackingId(trackingId, "__render")}
					isActive={isButtonActive}
					ref={ref}
				/>
			</ClickableArea>
		);
	}
);
ActionButton.displayName = "ActionButton";